'use client';
import React from 'react';
import Image from 'next/image';
import { Box } from '@mui/material';
import { useMyRoomEntry } from '@/app/components/MyRoom/useMyRoomEntry';
import { useRoomEntryAllowed } from '@/app/components/MyRoom/appCompat';
import { useTranslation } from '@/app/hooks/useTranslation';

// 홈 "종이접기 방 꾸미기" 배너. 시안(APP_01_Home > @마이룸) 기준으로
// 인기 게시글과 조커 소식 사이에 들어간다.
// 배너 이미지가 좌우 여백까지 포함한 프레임 통짜 export 라 풀블리드로 얹는다.
//
// 탭하면 방으로 바로 보낸다(useMyRoomEntry 규칙).
const MyRoomBanner: React.FC = () => {
    // 연동됐으면 본인 방, 아니면 샘플 방, 비로그인은 로그인으로.
    const handleClick = useMyRoomEntry();
    const roomEntryAllowed = useRoomEntryAllowed();
    const { t } = useTranslation();

    // 마이룸을 쓸 수 없는 앱(구버전)에서는 배너를 아예 그리지 않는다.
    if (!roomEntryAllowed) return null;

    return (
        <Box sx={{ backgroundColor: 'white' }}>
            <Box
                onClick={handleClick}
                role="button"
                tabIndex={0}
                aria-label={t('myroom_banner_aria_label', '종이접기 방 꾸미기 — 마이룸 가기')}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') handleClick();
                }}
                sx={{
                    cursor: 'pointer',
                    lineHeight: 0,
                    transition: 'transform .12s',
                    '&:active': { transform: 'scale(0.995)' },
                    '&:focus-visible': { outline: '2px solid #7B5CFA', outlineOffset: '-2px' },
                }}
            >
                <Image
                    src="/images/home_myroom_banner.png"
                    alt={t('myroom_banner_alt', '종이접기 방 꾸미기 - 3D공간에 나만의 종이접기를 전시해보세요.')}
                    width={750}
                    height={266}
                    quality={100}
                    style={{ width: '100%', height: 'auto', display: 'block' }}
                />
            </Box>
        </Box>
    );
};

export default MyRoomBanner;
